import React, {Fragment} from 'react';
import Component from 'components/component';

const positions = [
    {
        value: 'left_top',
        class: '_top-left'
    },
    {
        value: 'center_top',
        class: '_top'
    },
    {
        value: 'right_top',
        class: '_top-right'
    },
    {
        value: 'left_bottom',
        class: '_bottom-left'
    },
    {
        value: 'center_bottom',
        class: '_bottom'
    },
    {
        value: 'right_bottom',
        class: '_bottom-right'
    }
];

export default class BrandingPositionInput extends Component {

    static defaultProps = {
        name: 'branding_position',
        worldExclusive: false,
        inline: true,
        onChange(){}
    }

    render() {
        let style;
        let filteredPositions = positions;

        if (this.props.worldExclusive) {
            filteredPositions = positions.filter(item => !item.value.includes('center'));
            style = {
                width: this.props.inline ? 255 : 120
            };

        };
        return (
            <div className="branding-position" style={style}>
                {filteredPositions.map((item) => (
                    <Fragment key={this.props.name + item.value}>
                        <div className="branding-position-radio">
                            <input
                                type="radio"
                                className="branding-position-radio__input"
                                name={this.props.name}
                                id={this.props.name + item.value}
                                value={item.value}
                                onChange={this.props.onChange}
                                checked={this.props.value === item.value}
                            />
                            <label
                                htmlFor={this.props.name + item.value}
                                className={`branding-position-radio__label ${
                                    item.class
                                }`}
                            />
                        </div>
                        &nbsp;
                    </Fragment>
                ))}
            </div>
        );
    }
}